import { Component, Input } from '@angular/core';
import { AppService } from '../../app.service';
import { Environment } from '../../app/../../environments/environment';
import { Globals } from '../../globals';

@Component({
    selector: 'nav-sidebar',
    providers: [AppService],
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css'],
    inputs:['component']
})

export class SidebarComponent {        
   
    links: any[];     
    collapsed: Boolean = false;
    componentIcon: string;
    componentName: string;

    @Input() component :string;   

    constructor(private appService: AppService, private globals: Globals) {            
        this.setSidebarLink(); 
    }   

    /**
     * Set sidebar links
     * @param component 
     */
    setSidebarLink(component = this.component) {
        this.links = Environment.components;
        
        for (var i = 0; i < this.links.length; i++) {            
            if (this.component == this.links[i].routeName) {
                this.componentIcon = this.links[i].icon;
                this.componentName = this.links[i].name;
                this.links[i].selected = true;
                break;
            } else {
                this.links[i].selected = false;
            }
        }
    }  

    resizeEvent(){
        if(window.innerWidth < 760) {
            this.collapsed = true;
        }
        if(window.innerWidth > 760) {
            this.collapsed = false;
        }
    }

    /**
     * Collapsable side bar
     */
    collapseSidebar() {
        this.collapsed = !this.collapsed; 
    }

    /**
     * Set route
     * @param routeName route name
     * @param active if route is active
     */
    setRoute(routeName, active) {
        if (active) {
            let lastViewedComponent = JSON.parse(localStorage.getItem('lastComponent'));
            if(lastViewedComponent != undefined && lastViewedComponent != null && lastViewedComponent !== routeName) {
                localStorage.setItem('lastSearch', JSON.stringify([]));
                localStorage.setItem('filterList', JSON.stringify([]));
                localStorage.setItem('lastViewedPage', JSON.stringify(1));
                localStorage.removeItem('lastViewedAnchor');
            }
            this.appService.setRoute(routeName);
        }        
    }

    /**
     * Listen on change event
     */
    ngOnChanges() {        
        this.setSidebarLink(this.component);        
    }    
}